import {
  NetworkPointsResponse,
  NetworkPointsParams,
} from 'src/apis/network-points/types';
import { NetworkPointsRootRequest } from 'src/components/form/select/network-point-select/use-network-points-root';
import { Successful, useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type Options = {
  params: NetworkPointsParams;
  networkPointsRoot: Successful<NetworkPointsRootRequest>;
};

export function useNetworkPoints() {
  const networkPoints = useAxios(
    (axios, signal, { networkPointsRoot, params }: Options) => {
      const link = networkPointsRoot.response.data._links.getNetworkPoints.href;
      return axios.request<NetworkPointsResponse>({
        signal,
        url: urlTemplate.parse(link).expand({}),
        params,
      });
    },
    { neededOnPageLoad: false }
  );

  return networkPoints;
}

export type NetworkPointsRequest = ReturnType<typeof useNetworkPoints>;
